import ListItemMaterial, { ListItemProps } from '@mui/material/ListItem'
import type { FormContextValue } from 'dynamic-uniforms'
import { connectField, FormContext, useFormContext } from 'dynamic-uniforms'
import { lazy, ReactNode, Suspense, useMemo } from 'react'

import { Card } from '@mui/material'
import ListDelField from './ListDelField'

// Lazy load AutoField to break circular dependency
const AutoField = lazy(() => import('./AutoField'))

export type ListItemFieldProps = {
  children?: ReactNode
  dense?: ListItemProps['dense']
  disableGutters?: ListItemProps['disableGutters']
  divider?: ListItemProps['divider']
  removeIcon?: ReactNode
  removeItemCta?: string
  value?: unknown
  name: string
  [key: string]: any
}

function ListItem({
  children = (
    <Suspense fallback={<div>Loading...</div>}>
      <AutoField label={null} name="" />
    </Suspense>
  ),
  dense = true,
  disableGutters,
  divider,
  removeIcon,
  removeItemCta,
  name,
}: ListItemFieldProps) {
  const ctx = useFormContext()

  // Provide nested context so child fields resolve relative to this item
  const itemContext = useMemo<FormContextValue>(() => ({ ...ctx, namePrefix: name }), [ctx, name])

  return (
    <FormContext.Provider value={itemContext}>
      <ListItemMaterial
        sx={{ pl: 0, pr: 0, width: '100%', minWidth: 0 }}
        dense={dense}
        disableGutters={disableGutters}
        divider={divider}
      >
        <Card sx={{ px: 2, py: 1, width: '100%', minWidth: 0 }}>{children}</Card>

        <ListDelField name="" icon={removeIcon} cta={removeItemCta} />
      </ListItemMaterial>
    </FormContext.Provider>
  )
}

export default connectField<ListItemFieldProps>(ListItem, {
  initialValue: false,
})
